import styled from 'styled-components'
// import { BREAK_POINT_MD } from '@CSSVars/variables'

export const _AlertList = styled.div`
  @media screen and (min-width: 1776px) {
    max-width: 1776px;
    display: grid;
    grid-gap: 0 20px;
    grid-template-columns: repeat(2, 1fr);
  }
`

